export default {"src":"/_next/static/media/home-artwork-icon.af81aab2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};